import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../actions/DesignActions";
import {loadDesignJobs} from "../helper functions/LoadDesignJobs";

export function DesignFullList() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const dispatch = useDispatch()
    let sort = useSelector(state => state.designSortFull);
    let search = useSelector(state => state.designSearchFull);
    let filter = useSelector(state => state.designJobFilterFull);

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>All Design jobs</h1>
                    <p>A list of all design jobs</p>
                </div>
                <hr/>

                <div className="dropdown">
                    <div className="dropdown-btn btn-secondary"> Sort by:</div>
                    <div className="dropdown-content">
                        <a onClick={sort => dispatch(actions.SortNew("ALL"))}>Newest First</a>
                        <a onClick={sort => dispatch(actions.SortOld("ALL"))}>Oldest First</a>
                        <a onClick={sort => dispatch(actions.SortAtoZ("ALL"))}>A-Z</a>
                    </div>
                </div>
                <div className="search">
                    <input id="search-input" type="text" className="search-box"
                           placeholder="Which job are you looking for?"/>
                    <button className="search-btn btn-secondary btn"
                            onClick={search => dispatch(actions.fullSearch(document.getElementById("search-input").value, "ALL"))}> 🔍
                    </button>
                </div>


                <div className="dropdown mx-2">
                    <div className="dropdown-btn btn-secondary"> Filter by:</div>
                    <div className="dropdown-content">
                        <a onClick={filter => dispatch(actions.filter("NO DESIGNS"))}> New jobs</a>
                        <a onClick={filter => dispatch(actions.filter("DESIGNS UPLOADED"))}> Jobs with Designs </a>
                        <a onClick={filter => dispatch(actions.filter("DESIGN CHOSEN"))}> Jobs with a chosen design </a>
                        <a onClick={filter => dispatch(actions.filter("COMPLETED"))}> Completed jobs </a>
                    </div>
                </div>


                <div className="page-break"></div>
                <br/>

                {loadDesignJobs(sort, search, filter)}

                <div className="page-break"></div>
            </AuthenticatedTemplate>
        </div>
    );
}
